import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
	name: 'user',
	initialState: {
		iden: '',
		mail: '',
		name: '',
		avat: '',
		back: '',
		dark: false,
		role: '',
		comp: '',
		sapDB: '',
		budg: '',
		sap_user: '',
	},
	reducers: {
		setUserData: (state, action) => {
			const { iden, mail, name, avat, back, dark, role, comp, sapDB, budg, sap_user } = action.payload;
			state.iden = iden;
			state.mail = mail;
			state.name = name;
			state.avat = avat;
			state.back = back;
			state.dark = dark;
			state.role = role;
			state.comp = comp;
			state.sapDB = sapDB;
			state.budg = budg;
			state.sap_user = sap_user; // Ensure sap_user is set or default to empty string
		},
	},
});

export const { setUserData } = userSlice.actions;

export default userSlice.reducer;